class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        this.newsletterSessionKey = 'puko-newsletter-popup-seen';
        this.minimizeTimer = null;
        if (this.isMobileArticle()) {
            document.body.classList.add('newsletter-minimized');
        }
        if (this.getCookie('newsletter-popup') === '' && !this.hasSessionPopupSeen()){
            var popup = this.popup;

            setTimeout(function() {
                if (popup.isMobileArticle()) {
                    if (!document.body.classList.contains('newsletter-show')) {
                        document.body.classList.add('newsletter-minimized');
                    }
                    return;
                }
                document.body.classList.remove('newsletter-minimized');
                popup.markSessionPopupSeen();
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                if (this.isMobileArticle()) return;
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700)
        } else {
            // this.deleteCookie('newsletter-popup');
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        document.addEventListener('keyup', (event) => {
            if (event.key !== 'Escape' || event.defaultPrevented || !document.body.classList.contains('newsletter-show')) return;
            event.preventDefault();
            this.setMinimizedPopup();
        });

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setMinimizedPopup.bind(this)
        );

        this.querySelector('[data-open-newsletter-minimized]')?.addEventListener(
            'click',
            this.openMinimizedPopup.bind(this)
        );

        this.querySelector('#ContactPopup')?.addEventListener(
            'submit',
            this.onSubmit.bind(this)
        );

        this.dismissLabel = this.querySelector('label[for="dismiss"]');
        if (this.dismissLabel) {
        this.dismissLabel.addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
        }

        if(this.classList.contains('style-2')){
            this.copyButton = this.querySelector('.button-code--copy');
            if(this.copyButton){
                this.copyButton.addEventListener('click', () => {
                    this.inputField = this.querySelector('.code__input .field__input');
                    this.tooltip = this.copyButton.querySelector('.tooltip');
                    navigator.clipboard.writeText(this.inputField.value).then(() => {
                    this.tooltip.textContent =  this.tooltip.dataset.success_message;
                    });
                });
            }

            $('.halo-newsletter-popup.style-2 .products-grid:has(.product:nth-child(3))')?.slick({
                infinite: true,
                arrows: true,
                dots: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                slidesToShow: 2,
                slidesToScroll: 2,
                rtl: window.rtl_slick
            });
        }
    }

    isMobileArticle() {
        return document.body.classList.contains('template-article') &&
            window.matchMedia('(max-width: 767px)').matches;
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    hasSessionPopupSeen() {
        try {
            return window.sessionStorage.getItem(this.newsletterSessionKey) === 'true';
        } catch (error) {
            return false;
        }
    }

    markSessionPopupSeen() {
        try {
            window.sessionStorage.setItem(this.newsletterSessionKey, 'true');
        } catch (error) {}
    }

    setClosePopup() {
        clearTimeout(this.minimizeTimer);
        this.markSessionPopupSeen();
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        document.body.classList.remove('newsletter-ajax-morphing');
        document.body.classList.remove('newsletter-minimized');
        document.body.classList.remove('newsletter-opening-from-minimized');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)
    }

    setMinimizedPopup() {
        clearTimeout(this.minimizeTimer);
        this.markSessionPopupSeen();
        document.body.classList.remove('newsletter-opening-from-minimized');
        document.body.classList.add('newsletter-minimized', 'newsletter-ajax-morphing');
        document.body.classList.remove('newsletter-show');
        document.body.classList.remove('show-newsletter-image');

        this.minimizeTimer = setTimeout(() => {
            document.body.classList.remove('newsletter-ajax-morphing');
            const active = document.activeElement;
            if (document.body.classList.contains('newsletter-minimized') && !document.body.classList.contains('newsletter-show') && (active === document.body || this.contains(active))) {
                const opener = this.querySelector('[data-open-newsletter-minimized]');
                const rect = opener?.getBoundingClientRect();
                if (rect?.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight) opener.focus({preventScroll: true});
            }
        }, 560);
    }

    openMinimizedPopup() {
        clearTimeout(this.minimizeTimer);
        document.body.classList.remove('newsletter-ajax-morphing');
        document.body.classList.add('newsletter-opening-from-minimized', 'newsletter-show', 'show-newsletter-image');
        document.body.classList.remove('newsletter-minimized');
        this.minimizeTimer = setTimeout(() => {
            document.body.classList.remove('newsletter-opening-from-minimized');
        }, 260);
    }

    onSubmit() {
        document.body.classList.add('newsletter-submitting');
    }

    onBodyClickEvent(event){
        /* PUKO-COOKIE-CONSENT-GUARD: clicks on the Shopify cookie-consent UI must not
           count as "outside click" — otherwise accepting cookies silently closes the
           popup and suppresses it for a day. */
        if (event.target.closest && event.target.closest('[id^="shopify-pc__"]')) return;
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setMinimizedPopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);

